import axios from "@/axios/axios";
import { UserDocument, UserStatsDocument } from "@/interfaces/user.interfaces";
import { UserProjectDocument } from "@/interfaces/user.project.interfaces";

export async function fetchUsers(): Promise<UserDocument[]> {
  try {
    const res = await axios.get(`/user/all`);
    return res ? res.data : [];
  } catch (e: any) {
    console.log('fetchAccounts :', e.message);
    return [];
  }
}

export async function createUser(body: Partial<UserDocument>): Promise<UserDocument | null> {
  try {
    const res = await axios.post(`/user/add`, body);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('createAccount :', e.message);
    return null;
  }
}

export async function updateUser(userid: string, body: Partial<UserDocument>): Promise<UserDocument | null> {
  try {
    const res = await axios.put(`/user/${userid}`, body);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('updateAccount :', e.message);
    return null;
  }
}

export async function deleteUser(userid: string, authid: string): Promise<boolean> {
  try {
    const res = await axios.delete(`/user/${userid}/${authid}`);
    return res && res.status === 200;
  } catch (e: any) {
    console.log('deleteAccount :', e.message);
    return false;
  }
}

export async function fetchUsersProject(prjid: string): Promise<UserProjectDocument[]> {
  try {
    const res = await axios.get(`/user/project/all/${prjid}`);
    return res ? res.data : [];
  } catch (e: any) {
    console.log('fetchUsersProject :', e.message);
    return [];
  }
}

export async function addUserToProject(userid: string, prjid: string):  Promise<UserProjectDocument[]> {
  try {
    const res = await axios.post(`/user/project/add`, {user: userid, project: prjid});
    return res ? res.data : [];
  } catch (e: any) {
    console.log('addUserToProject :', e.message);
    return [];
  }
}

export async function removeUserProject(id: string):  Promise<UserProjectDocument[]> {
  try {
    const res = await axios.delete(`/user/project/del/${id}`);
    return res ? res.data : [];
  } catch (e: any) {
    console.log('removeUserProject :', e.message);
    return [];
  }
}

export async function UserStats(userid: string): Promise<UserStatsDocument | null> {
  try {
    const res = await axios.get(`/stats/user/${userid}`);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('UserStats :', e.message);
    return null;
  }
}

export async function resetPassword(authid: string): Promise<boolean> {
  try {
    const res = await axios.put(`/auth/reset/${authid}`);
    return res ? res.status === 200 : false
  } catch (e: any) {
    console.log('resetPassword :', e.message);
    return false;
  }
}
